/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface ApproveAllAutomatedRecourseBookings$Params {}

export function approveAllAutomatedRecourseBookings(
  http: HttpClient,
  rootUrl: string,
  params?: ApproveAllAutomatedRecourseBookings$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<number>>> {
  const rb = new RequestBuilder(rootUrl, approveAllAutomatedRecourseBookings.PATH, 'post');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<number>>;
    }),
  );
}

approveAllAutomatedRecourseBookings.PATH = '/service/v1/recoursebooking/approveAllAutomatedRecourseBookings';
